<template>
	<li :class="{'active': active, 'messages': true, 'has-messages': count && count > 0}">
		<a :href="link">
			{{ linkText }}
			<span v-if="count" class="count-bubble">{{ count }}</span>
		</a>
	</li>
</template>

<script>
export default {

	props: {
		active: {
			type: Boolean,
			required: true,
		},
		link: {
			type: String,
			required: true,
		},
		linkText: {
			type: String,
			required: true,
		},
		count: {
			type: Number,
			required: false,
		},
	}
}
</script>
